export default {
      id: "hourglass-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "icons.HITByrwA.svg#hourglass-usage",
      toString: function () {
        return this.url;
      }
    }